import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import Label from "../Label";
import { CompanyActionMenu } from "./CompanyActionMenu";
import {
  initialFinanceConfigObj,
} from "src/components/Team/teams.constants";

// Re-export for use in CompanyForm
export { initialFinanceConfigObj };

export const acceptableCurrencyList = [
  { value: "INR", title: "Indian Rupees" },
  { value: "CAD", title: "Canadian Dollars" },
];

export const getCompanyDefaultValues = () => ({
  subscriptionId: 1,
  emailId: "",
  name: "",
  address: {
    street: "",
    houseNumber: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
  },
  active: true,
  paymentConfirmationNo: "card",
  rootUser: "",
  comments: "",
  validUntil: "",
  locationLongitude: "",
  locationLatitude: "",
  paymentCurrency: acceptableCurrencyList[0]?.value || "",
  paymentGatewayId: "",
  paymentGatewayDetailsId: 0,
  transactionPercent: "",
  taxPercent: "",
  provider: {
    name: "AMIK Technologies",
    redIcon:
      "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/amik.png",
    greenIcon:
      "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/amik.png",
    icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/amik.png",
    greyIcon:
      "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/amik.png",
    countryCode: "+91",
  },
  companyProtocolType: "ocpp",
  token: "",
  cpoToken: "",
  emspToken: "",
  endpoint: "",
  partyId: "",
  role: "EMSP",
  countryCode: "IN",
  logo: "",
  domain: "amiktechnologies",
  financeConfig: initialFinanceConfigObj,
});

export const companyFormTabs = [
  { value: "general", label: "GENERAL" },
  { value: "finance", label: "FINANCE CONFIGURATION" },
  { value: "publishedChargers", label: "PUBLISHED CHARGERS" },
];

export const publishedChargerColumns = [
  {
    field: "chargepoint_id",
    headerName: "Chargebox ID",
    flex: 1.2,
    minWidth: 170,
  },
  {
    field: "chargepoint_name",
    headerName: "Name",
    flex: 1,
    minWidth: 140,
  },
  {
    field: "team_name",
    headerName: "Company",
    flex: 1,
    minWidth: 140,
    renderCell: ({ value }) => value ?? "-",
  },
  {
    field: "city",
    headerName: "City",
    flex: 0.8,
    minWidth: 110,
    renderCell: ({ value }) => value ?? "-",
  },
  {
    field: "totalConnectors",
    headerName: "Connectors",
    width: 110,
    type: "number",
  },
  {
    // Filtering and sorting run on the cell value, not on renderCell output, so the
    // value itself has to be the displayed text — otherwise filtering for "Active"
    // is matched against the raw "A"/"I" flag and never hits.
    field: "status",
    headerName: "Status",
    width: 100,
    valueGetter: ({ row }) => (row.status === "A" ? "Active" : "Inactive"),
  },
  {
    field: "published",
    headerName: "Published",
    width: 110,
    valueGetter: ({ row }) => (row.published ? "Yes" : "No"),
    renderCell: ({ value }) => (
      <Label color={value === "Yes" ? "success" : "warning"}>{value}</Label>
    ),
  },
  {
    field: "lastHeartbeatTimestamp",
    headerName: "Last Heartbeat",
    width: 180,
    renderCell: ({ value }) =>
      value ? (
        <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
          <span>{yearFirstDateTimeFormat(value)}</span>
        </Tooltip>
      ) : (
        "-"
      ),
  },
];

export const companyListColumns = (isReadOnly) => [
  {
    field: "name",
    headerName: "Name",
    width: 150,
    renderCell: ({ value, id }) => (
      <>
        {isReadOnly ? (
          value
        ) : (
          <Link underline="none" component={RouterLink} to={`${id}`}>
            {value}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "companyProtocolType",
    headerName: "Protocol Type",
    width: 120,
    valueFormatter: ({ value }) => value?.toUpperCase() || "OCPP",
  },
  {
    field: "partyId",
    headerName: "Party ID",
    width: 100,
    renderCell: ({ value }) => value ?? "-",
  },
  {
    field: "role",
    headerName: "OCPI Role",
    width: 100,
    // role is stored inconsistently ("emsp" and "EMSP" both occur), so normalise it
    // into the value itself to keep filtering and sorting predictable.
    valueGetter: ({ row }) => row.role?.toUpperCase() ?? "-",
  },
  {
    field: "creationTime",
    headerName: "Creation Time",
    width: 180,
    type: "date",
    renderCell: ({ value }) =>
      value ? (
        <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
          <span>{yearFirstDateTimeFormat(value)}</span>
        </Tooltip>
      ) : (
        "-"
      ),
  },
  {
    field: "createdBy",
    headerName: "Created By",
    width: 120,
  },
  {
    field: "Actions",
    width: 70,
    sortable: false,
    renderCell: ({ id, row }) => {
      return <CompanyActionMenu id={id} row={row} />;
    },
  },
];
